import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { InputGeneral } from '../../shared/inputs/input-general/input-general';
import { InputGeneralTextComponent } from '../../shared/inputs/input-general-text/input-general-text.component';
import { LocationService } from '../../shared/services/location.service';
import { GeneralService } from '../../shared/services/general.service';
import {
  ApiResponseLocationSite,
  LocationDetailResponse,
  WorkFlowType,
} from '../../shared/models/location-model/location.model';
import { InputGeneralRadioButtonComponent } from '../../shared/inputs/input-general-radio-button/input-general-radio-button.component';
import { CatalogsService } from '../../shared/services/catalogs.service';
import { ApiResponseCatalog, WorkFlow } from '../../shared/models/catalogs/catalogs-model';
import { InputGeneralSelectComponent } from '../../shared/inputs/input-general-select/input-general-select.component';
import { TicketService } from '../../shared/services/ticket.service';
import { InputFileLightComponent } from '../../shared/inputs/input-file-light/input-file-light.component';
import { EditFieldValue } from '../../shared/models/ticket-model/tiket.model';
import { FormDinamicComponent } from '../../shared/components-generals/form-dinamic/form-dinamic.component';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-high-request',
  imports: [
    InputGeneral,
    MatButtonModule,
    ReactiveFormsModule,
    InputGeneralRadioButtonComponent,
    InputGeneralSelectComponent,
    LoadGeneralComponent,
    FormDinamicComponent,
    TranslateModule,
  ],
  templateUrl: './high-request.html',
  styleUrl: './high-request.css',
})
export class HighRequest {
  public load = false;
  // Asegúrate de inyectar el servicio correcto en el constructor si no existe

  public formGroup: FormGroup;
  public locationDetail: LocationDetailResponse | null = null;
  public workFlowTypes: WorkFlowType[] = [];
  public workFlows: WorkFlow[] = [];
  public workFlowsAux: WorkFlow[] = [];
  public workFlowsSelect: WorkFlow | null = null;
  public codeDependencies = [{ codeSource: 6, codeTarget: 7, codeMunicipality: 8 }];

  constructor(
    private fb: FormBuilder,
    private locationService: LocationService,
    private catalogsService: CatalogsService,
    private generalService: GeneralService,
    private ticketService: TicketService,
  ) {
    this.formGroup = this.fb.group({
      key: ['', [Validators.required, Validators.minLength(3)]],
      socio: [{ value: '', disabled: true }],
      cliente: [{ value: '', disabled: true }],
      proyecto: [{ value: '', disabled: true }],
      cliente2: [{ value: '', disabled: true }],
      noSerie: [{ value: '', disabled: true }],
      marca: [{ value: '', disabled: true }],
      modelo: [{ value: '', disabled: true }],
      tipoConectividad: [{ value: '', disabled: true }],
      ubicacion: [{ value: '', disabled: true }],
      prioridad: [{ value: '', disabled: true }],
      domicilio: [{ value: '', disabled: true }],
      noExterior: [{ value: '', disabled: true }],
      noInterior: [{ value: '', disabled: true }],
      telefono: [{ value: '', disabled: true }],
      codigoPostal: [{ value: '', disabled: true }],
      colonia: [{ value: '', disabled: true }],
      poblacion: [{ value: '', disabled: true }],
      estado: [{ value: '', disabled: true }],
      zona: [{ value: '', disabled: true }],
      latitud: [{ value: '', disabled: true }],
      longitud: [{ value: '', disabled: true }],

      archivoProblema: [{ value: '', disabled: true }],
      nombreContacto: [
        { value: '', disabled: false },
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(/^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/),
        ],
      ],
      telefonoContacto: [{ value: '', disabled: false }, [Validators.required]],
      correoContacto: [{ value: '', disabled: false }, [Validators.required, Validators.email]],
      tipoFlujo: [{ value: '', disabled: false }, [Validators.required]],
      flujo: [{ value: '', disabled: false }, [Validators.required]],
    });

    this.formGroup.get('tipoFlujo')?.valueChanges.subscribe((value) => {
      this.filterWorkFlowsByType(value);
    });

    this.formGroup.get('flujo')?.valueChanges.subscribe((value) => {
      this.workFlowsSelect = this.workFlows.find((wf) => wf.Id === value) || null;
    });

    const urlParams = new URLSearchParams(window.location.search);
    const locationId = urlParams.get('locationId');

    if (locationId !== null) {
      this.getLocationDetail(Number(locationId));
      this.formGroup.get('key')?.disable();
    } else {
      this.formGroup.get('tipoFlujo')?.disable();
      this.formGroup.get('flujo')?.disable();
      this.generalService
        .subscribeFormSimple(this.formGroup.get('key') as FormControl)
        .subscribe((value) => {
          if (value && this.formGroup.get('key')?.valid) {
            this.getLocationDetailParams();
          }
        });
    }
  }

  public getLocationDetail(id: number): void {
    this.load = true;
    const locationDetail$ = this.locationService.getLocationDetail(id);
    const getWorkFlow$ = this.catalogsService.getWorkFlow();

    this.generalService.getServices([locationDetail$, getWorkFlow$]).then((responses) => {
      const locationResponse =
        responses[0] as ApiResponseLocationSite<LocationDetailResponse> | null;

      if (locationResponse && locationResponse.Data) {
        this.locationDetail = locationResponse.Data;
        this.setValueLocationDetail();
      }
      const workFlowResponse = responses[1] as ApiResponseCatalog<WorkFlow[]> | null;
      this.workFlows = workFlowResponse?.Data || [];

      this.locationService
        .getWorkFlowType(this.locationDetail?.CustomerId || 0)
        .subscribe((res) => {
          this.load = false;
          this.workFlowTypes = res?.Data || [];
        });
    });
  }

  public getLocationDetailParams(): void {
    this.load = true;
    const locationDetail$ = this.locationService.getLocationDetailByKey(
      this.formGroup.get('key')?.value,
    );
    const getWorkFlow$ = this.catalogsService.getWorkFlow();

    this.generalService.getServices([locationDetail$, getWorkFlow$]).then((responses) => {
      const locationResponse =
        responses[0] as ApiResponseLocationSite<LocationDetailResponse> | null;

      this.locationDetail = locationResponse?.Data || null;
      this.setValueLocationDetail();

      const workFlowResponse = responses[1] as ApiResponseCatalog<WorkFlow[]> | null;
      this.workFlows = workFlowResponse?.Data || [];

      if (this.locationDetail) {
        this.formGroup.get('tipoFlujo')?.enable();
        this.formGroup.get('flujo')?.enable();
      } else {
        this.formGroup.get('tipoFlujo')?.disable();
        this.formGroup.get('flujo')?.disable();
      }

      this.locationService
        .getWorkFlowType(this.locationDetail?.CustomerId || 0)
        .subscribe((res) => {
          this.workFlowTypes = res?.Data || [];
          this.load = false;
        });
    });
  }

  public setValueLocationDetail(): void {
    this.load = true;
    if (this.locationDetail) {
      const mapped = {
        key: this.locationDetail.Key,
        ubicacion: this.locationDetail.Description,
        prioridad: this.locationDetail.Status,
        domicilio: this.locationDetail.Address,
        codigoPostal: this.locationDetail.PostalCode,
        colonia: this.locationDetail.Locality,
        poblacion: this.locationDetail.City,
        estado: this.locationDetail.State,
        zona: this.locationDetail.Country,
        latitud: this.locationDetail.Latitude,
        longitud: this.locationDetail.Longitude,
        noExterior: this.locationDetail.StreetNumber,
        noInterior: this.locationDetail.ApartmentNumber,
      };
      this.generalService.viewSnacAlert('Localización encontrada', 'normal', 'Datos encontrados');
      this.formGroup.patchValue(mapped);
    } else {
      this.generalService.viewSnacAlert(
        'No se encontró información para la clave ingresada',
        'alert',
        'Localización no encontrada',
      );
      this.formGroup.patchValue({
        ubicacion: '',
        prioridad: '',
        domicilio: '',
        codigoPostal: '',
        colonia: '',
        poblacion: '',
        estado: '',
        zona: '',
        latitud: '',
        longitud: '',
        noExterior: '',
        noInterior: '',
      });
    }
  }

  public filterWorkFlowsByType(type: number): void {
    this.workFlowsAux = this.workFlows.filter((wf) => wf.WorkFlowTypeId === type);
  }

  public async ticketCreate(): Promise<void> {
    if (this.formGroup.invalid) {
      this.generalService.viewSnacAlert(
        'Por favor, completa todos los campos requeridos correctamente.',
        'alert',
        'Formulario incompleto',
      );
      this.formGroup.markAllAsTouched();
      return;
    }

    this.load = true;
    const WorkFlowEditFields: EditFieldValue[] = [];

    if (this.workFlowsSelect?.WorkFlowEditFields) {
      for (const field of this.workFlowsSelect.WorkFlowEditFields) {
        if (field.ComponentType === 'File') {
          let fileBytes: string | null = null;
          let fileName: string | null = null;

          const file = field.FormControl?.value[0] as File;

          if (file) {
            fileName = file.name;
            fileBytes = await this.fileToBase64(file);
          }

          WorkFlowEditFields.push({
            EditFieldId: field.Id,
            ClosingFieldId: field.ClosingFieldId,
            Value: '',
            FileBytes: fileBytes,
            FileName: fileName || '',
          });
        } else {
          WorkFlowEditFields.push({
            EditFieldId: field.Id,
            ClosingFieldId: field.ClosingFieldId,
            Value: field.FormControl?.value,
          });
        }
      }
    }

    const form = this.formGroup.getRawValue();
    const body = {
      CustomerId: this.locationDetail?.CustomerId || 0,
      // PartnerId: this.workFlowsSelect ? this.workFlowsSelect.PartnerId : null, // eliminar
      WorkFlowId: form.flujo || '',
      // WorkFlowTypeId: this.workFlowsSelect ? this.workFlowsSelect.WorkFlowTypeId : '', // quitar
      LocationId: this.locationDetail ? this.locationDetail.Id : '',
      SerialNumber: form.noSerie || '',
      WorkFlowEditFields: WorkFlowEditFields,
      PostalCodeId: this.locationDetail?.PostalCodeId || '',
      StreetName: this.locationDetail?.StreetName || '',
      StreetNumber: this.locationDetail?.StreetNumber || '',
      ApartmentNumber: this.locationDetail?.ApartmentNumber || '',
      POCFullName: form.nombreContacto || '',
      POCPhoneNumber: form.telefonoContacto || '',
      POCMobileNumber: '',
      POCEmail: form.correoContacto || '',
      Project: 'Prueba',
      SourceTypeId: 2,
    };

    this.ticketService.ticketCreate(body).subscribe((ress: any) => {
      if (ress && ress.Data) {
        const ticketId = Number(
          new URLSearchParams(String(ress.Data).split('?')[1] ?? '').get('id') ?? 0,
        );
        this.generalService.viewSnacAlert(`Tiket creado ${ticketId}`, 'normal', 'Tiket creado');
      }
      this.generalService.goToUrl(['home'], { statusSelected: 1 }, true);
      this.load = false;
      // this.getTicketDetail(ticketId);
    });
  }

  fileToBase64(file: File | Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result.split(',')[1];
        resolve(base64);
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  public getTicketDetail(id: number): void {
    this.ticketService.getTicketDetail(id).subscribe((response) => {
      if (response && response.Data) {
        this.generalService.viewSnacAlert(
          `Tiket con folio ${response.Data.Key} creado correctamente.`,
          'normal',
          'Tiket creado',
        );
        this.generalService.goToUrl(['home'], { statusSelected: 1 }, true);
      } else {
        this.generalService.viewSnacAlert(
          'No se pudo crear el tiket, por favor intenta nuevamente.',
          'error',
          'Error al crear tiket',
        );
      }
      this.load = false;
    });
  }
}
